"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _uuid = require("uuid");

var _variables = require("../common/variables.js");

var _useTheme = _interopRequireDefault(require("../useTheme"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DxcToggleGroup = function DxcToggleGroup(_ref) {
  var label = _ref.label,
      helperText = _ref.helperText,
      defaultValue = _ref.defaultValue,
      value = _ref.value,
      onChange = _ref.onChange,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      options = _ref.options,
      margin = _ref.margin,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === void 0 ? false : _ref$multiple,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex;
  var colorsTheme = (0, _useTheme["default"])();

  var _useState = (0, _react.useState)(defaultValue !== null && defaultValue !== void 0 ? defaultValue : multiple ? [] : -1),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      selectedValue = _useState2[0],
      setSelectedValue = _useState2[1];

  var _useState3 = (0, _react.useState)("toggle-group-".concat((0, _uuid.v4)())),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 1),
      toggleGroupId = _useState4[0];

  var handleToggleChange = function handleToggleChange(selectedOption) {
    var newSelectedOptions;

    if (value == null) {
      if (multiple && Array.isArray(selectedValue)) {
        newSelectedOptions = selectedValue.map(function (value) {
          return value;
        });

        if (newSelectedOptions.includes(selectedOption)) {
          var index = newSelectedOptions.indexOf(selectedOption);
          newSelectedOptions.splice(index, 1);
        } else {
          newSelectedOptions.push(selectedOption);
        }

        setSelectedValue(newSelectedOptions);
      } else setSelectedValue(selectedOption === selectedValue ? null : selectedOption);
    } else if (multiple) {
      newSelectedOptions = Array.isArray(value) ? value.map(function (v) {
        return v;
      }) : value;

      if (newSelectedOptions.includes(selectedOption)) {
        var _index = newSelectedOptions.indexOf(selectedOption);

        newSelectedOptions.splice(_index, 1);
      } else newSelectedOptions.push(selectedOption);
    }

    onChange === null || onChange === void 0 ? void 0 : onChange(multiple ? newSelectedOptions : selectedOption);
  };

  var handleKeyPress = function handleKeyPress(event, optionValue) {
    event.preventDefault();
    if (!disabled && (event.nativeEvent.code === "Enter" || event.nativeEvent.code === "Space")) handleToggleChange(optionValue);
  };

  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: colorsTheme.toggleGroup
  }, /*#__PURE__*/_react["default"].createElement(ToggleGroup, {
    margin: margin,
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement(Label, {
    htmlFor: toggleGroupId,
    disabled: disabled
  }, label), /*#__PURE__*/_react["default"].createElement(HelperText, {
    disabled: disabled
  }, helperText), /*#__PURE__*/_react["default"].createElement(OptionsContainer, {
    id: toggleGroupId,
    role: multiple ? "group" : "radiogroup"
  }, options.map(function (option, i) {
    return /*#__PURE__*/_react["default"].createElement(ToggleContainer, {
      selected: multiple ? value ? Array.isArray(value) && value.includes(option.value) : Array.isArray(selectedValue) && selectedValue.includes(option.value) : value ? option.value === value : option.value === selectedValue,
      role: multiple ? "switch" : "radio",
      "aria-checked": multiple ? value ? Array.isArray(value) && value.includes(option.value) : Array.isArray(selectedValue) && selectedValue.includes(option.value) : value ? option.value === value : option.value === selectedValue,
      tabIndex: !disabled ? tabIndex : -1,
      onClick: function onClick() {
        return !disabled && handleToggleChange(option.value);
      },
      isFirst: i === 0,
      isLast: i === options.length - 1,
      isIcon: option.icon,
      optionLabel: option.label,
      disabled: disabled,
      onKeyPress: function onKeyPress(event) {
        handleKeyPress(event, option.value);
      },
      key: "toggle-".concat(i, "-").concat(option.label)
    }, /*#__PURE__*/_react["default"].createElement(OptionContent, null, option.icon && /*#__PURE__*/_react["default"].createElement(IconContainer, {
      optionLabel: option.label
    }, typeof option.icon === "string" ? /*#__PURE__*/_react["default"].createElement(Icon, {
      src: option.icon
    }) : option.icon), option.label && /*#__PURE__*/_react["default"].createElement(LabelContainer, null, option.label)));
  }))));
};

var Label = _styledComponents["default"].label(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n"])), function (props) {
  return props.disabled ? props.theme.disabledLabelFontColor : props.theme.labelFontColor;
}, function (props) {
  return props.theme.labelFontFamily;
}, function (props) {
  return props.theme.labelFontSize;
}, function (props) {
  return props.theme.labelFontStyle;
}, function (props) {
  return props.theme.labelFontWeight;
}, function (props) {
  return props.theme.labelLineHeight;
});

var HelperText = _styledComponents["default"].span(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n"])), function (props) {
  return props.disabled ? props.theme.disabledHelperTextFontcolor : props.theme.helperTextFontColor;
}, function (props) {
  return props.theme.helperTextFontFamily;
}, function (props) {
  return props.theme.helperTextFontSize;
}, function (props) {
  return props.theme.helperTextFontStyle;
}, function (props) {
  return props.theme.helperTextFontWeight;
}, function (props) {
  return props.theme.helperTextLineHeight;
});

var ToggleGroup = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  display: inline-flex;\n  flex-direction: column;\n  margin: ", ";\n  margin-top: ", ";\n  margin-right: ", ";\n  margin-bottom: ", ";\n  margin-left: ", ";\n"])), function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) !== "object" ? _variables.spaces[props.margin] : "0px";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.top ? _variables.spaces[props.margin.top] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.right ? _variables.spaces[props.margin.right] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.bottom ? _variables.spaces[props.margin.bottom] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.left ? _variables.spaces[props.margin.left] : "";
});

var OptionsContainer = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: row;\n  width: max-content;\n  opacity: 1;\n  height: calc(48px - 4px - 4px);\n  border-width: ", ";\n  border-style: ", ";\n  border-radius: ", ";\n  border-color: ", ";\n  background-color: ", ";\n  padding: 4px;\n  margin-top: ", ";\n"])), function (props) {
  return props.theme.containerBorderThickness;
}, function (props) {
  return props.theme.containerBorderStyle;
}, function (props) {
  return props.theme.containerBorderRadius;
}, function (props) {
  return props.theme.containerBorderColor;
}, function (props) {
  return props.theme.containerBackgroundColor;
}, function (props) {
  return props.theme.containerMarginTop;
});

var ToggleContainer = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin-right: ", ";\n\n  ", "\n"])), function (props) {
  return !props.isLast && "4px";
}, function (props) {
  return "\n    background-color: ".concat(props.selected ? props.disabled ? props.theme.selectedDisabledBackgroundColor : props.theme.selectedBackgroundColor : props.disabled ? props.theme.unselectedDisabledBackgroundColor : props.theme.unselectedBackgroundColor, ";\n    border-width: ").concat(props.theme.optionBorderThickness, ";\n    border-style: ").concat(props.theme.optionBorderStyle, ";\n    border-radius: ").concat(props.theme.optionBorderRadius, ";\n    padding-left: ").concat(props.optionLabel && props.isIcon || props.optionLabel && !props.isIcon ? props.theme.labelPaddingLeft : props.theme.iconPaddingLeft, ";\n    padding-right: ").concat(props.optionLabel && props.isIcon || props.optionLabel && !props.isIcon ? props.theme.labelPaddingRight : props.theme.iconPaddingRight, ";\n    ").concat(!props.disabled ? ":hover {\n          background-color: ".concat(props.selected ? props.theme.selectedHoverBackgroundColor : props.theme.unselectedHoverBackgroundColor, ";\n        }\n        :active {\n          background-color: ").concat(props.selected ? props.theme.selectedActiveBackgroundColor : props.theme.unselectedActiveBackgroundColor, ";\n          color: #ffffff;\n        }        \n        :focus {\n          border-color: transparent;\n          box-shadow: 0 0 0 ").concat(props.theme.optionFocusBorderThickness, " ").concat(props.backgroundType === "dark" ? props.theme.focusColorOnDark : props.theme.focusColor, ";\n        }\n        &:focus-visible {\n          outline: none;\n        }\n        cursor: pointer;\n        color: ").concat(props.selected ? props.theme.selectedFontColor : props.theme.unselectedFontColor, ";\n") : "color: ".concat(props.selected ? props.theme.selectedDisabledFontColor : props.theme.unselectedDisabledFontColor, ";\n        cursor: not-allowed;"), "\n  ");
});

var LabelContainer = _styledComponents["default"].span(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  font-family: ", ";\n  font-size: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n"])), function (props) {
  return props.theme.optionLabelFontFamily;
}, function (props) {
  return props.theme.optionLabelFontSize;
}, function (props) {
  return props.theme.optionLabelFontStyle;
}, function (props) {
  return props.theme.optionLabelFontWeight;
});

var OptionContent = _styledComponents["default"].div(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"])));

var Icon = _styledComponents["default"].img(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])([""])));

var IconContainer = _styledComponents["default"].div(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-right: ", ";\n  height: 24px;\n  width: 24px;\n  overflow: hidden;\n  display: flex;\n  img,\n  svg {\n    height: 100%;\n    width: 100%;\n  }\n"])), function (props) {
  return props.optionLabel && props.theme.iconMarginRight;
});

var _default = DxcToggleGroup;
exports["default"] = _default;